var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Jcgl),
      expression: "Jcgl"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("工资申请单")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("城市 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.condition.city_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "city_id", $$v)
      },
      expression: "condition.city_id"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("处罚日期 ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.condition.current_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "current_date", $$v)
      },
      expression: "condition.current_date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("岗位 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.post_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "post_id", $$v)
      },
      expression: "condition.post_id"
    }
  }, _vm._l((_vm.postList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "15px"
    }
  }, [_c('span', [_vm._v("姓名 ")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.condition.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.condition, "staff_name", $$v)
      },
      expression: "condition.staff_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("状态 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.reviewer_state),
      callback: function($$v) {
        _vm.$set(_vm.condition, "reviewer_state", $$v)
      },
      expression: "condition.reviewer_state"
    }
  }, _vm._l((_vm.ztList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("类别 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "150px"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.dictionaries_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "dictionaries_id", $$v)
      },
      expression: "condition.dictionaries_id"
    }
  }, _vm._l((_vm.dictionariesList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.data,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "50px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Del(null)
      }
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("新增")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "2% 3% 0 3%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "540"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "组织架构",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "city_id",
      "align": "center",
      "label": "城市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "post_name",
      "align": "center",
      "label": "职位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "staff_name",
      "align": "center",
      "label": "姓名",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "dictionaries_data",
      "align": "center",
      "label": "类别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "current_date",
      "align": "center",
      "label": "时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reason",
      "align": "center",
      "label": "原因",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money",
      "align": "center",
      "label": "金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "状态",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '0'),
            expression: "scope.row.reviewer_state === '0'"
          }],
          attrs: {
            "src": require("../../../assets/待审批.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '1'),
            expression: "scope.row.reviewer_state === '1'"
          }],
          attrs: {
            "src": require("../../../assets/已同意.png")
          }
        }), _vm._v(" "), _c('img', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.reviewer_state === '2'),
            expression: "scope.row.reviewer_state === '2'"
          }],
          attrs: {
            "src": require("../../../assets/stateImg/状态_已驳回.png")
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/编辑.png")
          },
          on: {
            "click": function($event) {
              return _vm.Edit(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])]), _vm._v(" "), _c('add', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showadd),
      expression: "showadd"
    }],
    ref: "adds"
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69303d4c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Jcgl/Jcgl.vue
// module id = null
// module chunks = 